import React from "react";
import {Button} from "reactstrap";
import Tooltip from "@material-ui/core/Tooltip";
import PropTypes from "prop-types";


const hasPermission = (option) => {
    if(!option)
        return true

    let result = false
    let perm = (localStorage.getItem('permission') != '' ? JSON.parse(localStorage.getItem('permission')) : null);
    if (perm != null) {
        switch (option) {
            case "add":
                result = perm.allowAdd;
                break;
            case "edit":
                result = perm.allowEdit;
                break;
            case "delete":
                result = perm.allowDelete;
                break;
            case "gallery":
                result = perm.allowGallery;
                break;
            case "schedule":
                result = perm.allowSchedule;
                break;
            case "sync_firebase":
                result = perm.allowSync;
                break;
            case "prices":
                result = perm.allowPrices;
                break;
            case "search":
                result = perm.allowSearch;
                break;
        }
    }
    return result;
}

export const GenericButton = ({
    style,
    icon,
    label,
    toolTip,
    permission = 'search',
    onClick,
    disabled = false,
    type = 'button',
    loading = false,
    iconLoading = 'fa-spinner',
    clazzName = '',
    stackedIcon = ''
}) => {

    const completeIconLoading = iconLoading + " fa-spin";

    const setClassName = () => {
        let className = ""

        switch (style) {
            case "primary":
                className = "btn-add ml-auto ml-2";
                break;
            case "secondary":
                className = "btn-cancel ml-auto ml-2";
                break;
            case "table":
                className = "btn-actions-table ml-2";
                break;
            case "success":
                className = "btn-success";
                break;
            case "success-secondary":
                className = "success-secondary-button";
                break;
            case "danger":
                className = "btn-danger";
                break;
            case "danger-secondary":
                className = "danger-secondary-button ml-2";
                break;
            case "warning":
                className = "btn-sync ml-auto";
                break;
            case "warning-secondary":
                className = "warning-secondary-button";
                break;
            case "info":
                className = "btn-info";
                break;
            case "info-secondary":
                className = "btn-info";
                break;
            default:
                className = "btn-add ml-auto ml-2";
                break;
        }

        return className + " " + clazzName + " ";
    }

    const setIconClassName = () => {
        let className = ""

        switch (style) {
            case "primary":
                className = "fas fa-save";
                break;
            case "secondary":
                className = "fas " + icon ;
                break;
            case "table":
                className = "fas " + icon ;
                break;
            case "success":
                className = "btn-success";
                break;
            case "success-secondary":
                className = "fas " + icon;
                break;
            case "danger":
                className = "fas " + icon;
                break;
            case "danger-secondary":
                className = "fas " + icon ;
                break;
            case "warning":
                className = "fas fa-sync btn-icon";
                break;
            case "warning-secondary":
                className = "fas " + icon ;
                break;
            case "info":
                className = "btn-info";
                break;
            case "info-secondary":
                className = "btn-info";
                break;
            default:
                className = "fas " + icon ;
                break;
        }

        className += " " + (icon && label ? " btn-icon" : "");

        if(loading)
            className += ` ${completeIconLoading}`;

        return className;
    }



    if (hasPermission(permission)) {
        return (
            <Tooltip title={toolTip} placement="bottom">
                <Button className={setClassName() + 'btn-stack-icon'} onClick={onClick} disabled={disabled} type={type}   >
                    { label }
                    {
                        icon && <span className={'stack-1'}>
                            <i className={setIconClassName()}/>
                        </span>
                    }

                    {
                        stackedIcon && <span className={'stack-2'}>
                            <i className="fa fa-exclamation-circle text-danger"/>
                        </span>
                    }
                </Button>
            </Tooltip>
        )
    } else {
        return null;
    }
}

GenericButton.propTypes = {
    style: PropTypes.oneOf(["primary", "secondary", "table", "success", "success-secondary", "danger", "danger-secondary", "warning", "warning-secondary", "info", "info-secondary"]).isRequired,
    icon: PropTypes.string,
    label: PropTypes.string,
    toolTip: PropTypes.string.isRequired,
    permission: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    type: PropTypes.oneOf(["button", "submit", "reset"])
};